import React, { useState } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Button from '../components/Button/Button';
import InputField from '../components/Auth/InputField';
import TextInputField from '../components/Auth/TextInputField';
import Toast from '../components/Toast/Toast';
import SupportForm from '../components/PageSections/SupportForm';
import {
  FaMapMarkerAlt,
} from 'react-icons/fa';
import linkCircle from '../assets/icons/LinkCircle.png';
import callImg from '../assets/icons/Call.png';
import emailImg from '../assets/icons/emailLogo.png';
import locationIcon from '../assets/icons/location.png';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    query: ''
  });

  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setToastMessage('Copied to clipboard!');
      setToastVisible(true);
    }).catch(err => {
      console.error('Failed to copy:', err);
      setToastMessage('Failed to copy');
      setToastVisible(true);
    });
  };

  return (
    <div className="contact-page">
      <Navbar />

      <Toast 
        message={toastMessage} 
        isVisible={toastVisible} 
        onClose={() => setToastVisible(false)} 
      />

      {/* Section 1: You Still have a Question? */}
      <section className="question-section">
        <div className="section-header">
          <img src={linkCircle} alt="Link" className="header-icon" />
          <h2>
            You Still have a <span className="highlight">Question?</span>
          </h2>
          <div className="header-divider" />
          <p className="header-description">
            Feel free to connect with us, if you cannot find the answer you're
            looking for please contact us.
          </p>
        </div>
      </section>

      {/* Section 2: Contact Cards - Email & Phone */}
      <section className="contact-cards-section">
        <div className="contact-cards-container">
          {/* Email Card */}
          <div className="contact-card">
            <div className="contact-card-header">
              <h3 className="contact-card-title">contact@risoapp.com</h3>
              <button className="copy-icon-btn" onClick={() => copyToClipboard('contact@risoapp.com')} aria-label="Copy email">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="9" width="13" height="13" rx="2" stroke="white" strokeWidth="2"/>
                  <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="white" strokeWidth="2"/>
                </svg>
              </button>
            </div>
            <p className="contact-card-text">The best way to get answer faster.</p>
            <img src={emailImg} alt="Email" className="contact-card-bg-image" />
          </div>

          {/* Phone Card */}
          <div className="contact-card">
            <div className="contact-card-header">
              <div className="phone-numbers">
                <h3 className="contact-card-title">+91 76761 87272</h3>
                <h3 className="contact-card-title">+91 8249790076</h3>
              </div>
              <button className="copy-icon-btn" onClick={() => copyToClipboard('+91 76761 87272')} aria-label="Copy phone number">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="9" width="13" height="13" rx="2" stroke="white" strokeWidth="2"/>
                  <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="white" strokeWidth="2"/>
                </svg>
              </button>
            </div>
            <p className="contact-card-text">We are always happy to help.</p>
            <img src={callImg} alt="Call" className="contact-card-bg-image" />
          </div>
        </div>
      </section>

      {/* Section 3: Want to Visit us */}
      <section className="visit-section">
        <div className="section-header">
          <img src={locationIcon} alt="Location" className="header-icon" />
          <h2>
            Want to <span className="highlight">Visit us</span>
          </h2>
          <div className="header-divider2" />
          <p className="header-description">
            Feel free to visit us, for any more clarification or
            
            clarifying any doubts of yours
          </p>
        </div>
      </section>

      {/* Section 4: Office Location Cards */}
      <section className="office-cards-section">
        <div className="office-cards-container">
          {/* Registered Office */}
          <div className="office-card">
            <div className="office-card-content">
              <h6 className="office-card-label">Registered office</h6>
              <p className="office-card-address">
                Khata No: 1530/13464,
                <br />
                Alkapuri Cmplx Khodasingi,
                <br />
                Engineering School,
                <br />
                Ganjam, Brahmapur Sadar,
                <br />
                Odisha, 760010
              </p>
            </div>
            <div className="office-card-button">
              <Button variant="teal" showArrow={false}>
                VIEW IN MAPS
                <FaMapMarkerAlt style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </div>

          {/* Head Office */}
          <div className="office-card">
            <div className="office-card-content">
              <h6 className="office-card-label">Head office</h6>
              <p className="office-card-address">
                Rajeshwari Layout,
                <br />
                Munnekollal, Bengaluru,
                <br />
                Karnataka, 560066
              </p>
            </div>
            <div className="office-card-button">
              <Button variant="teal" showArrow={false}>
                VIEW IN MAPS
                <FaMapMarkerAlt style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </div>

          {/* Branch Office */}
          <div className="office-card">
            <div className="office-card-content">
              <h6 className="office-card-label">Branch office</h6>
              <p className="office-card-address">
                IIT Bhubaneswar Research
                <br />
                and Entrepreneurship Park,
                <br />
                behind Hotel Swosti
                <br />
                Premium, Gajapati Nagar,
                <br />
                Bhubaneswar, Odisha,
                <br />
                751013
              </p>
            </div>
            <div className="office-card-button">
              <Button variant="teal" showArrow={false}>
                VIEW IN MAPS
                <FaMapMarkerAlt style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Support Form */}
      <SupportForm />

      <Footer />
    </div>
  );
};

export default ContactUs;
